"use strict";

/**
 * Character classes and associated utilities for the 2nd edition of XML 1.1.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
//
// Fragments.
//
exports.CHAR = "\x01-\uD7FF\uE000-\uFFFD\uD800\uDC00-\uDBFF\uDFFF";
exports.RESTRICTED_CHAR = "\x01-\b\x0B\f\x0E-\x1F\x7F-\x84\x86-\x9F";
exports.S = " \t\r\n";
// tslint:disable-next-line:max-line-length
exports.NAME_START_CHAR = ":A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
exports.NAME_CHAR = "-" + exports.NAME_START_CHAR + ".0-9\xB7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
exports.CHAR_RE = new RegExp("^[" + exports.CHAR + "]$", "u");
exports.RESTRICTED_CHAR_RE = new RegExp("^[" + exports.RESTRICTED_CHAR + "]$", "u");
exports.S_RE = new RegExp("^[" + exports.S + "]+$", "u");
exports.NAME_START_CHAR_RE = new RegExp("^[" + exports.NAME_START_CHAR + "]$", "u");
exports.NAME_CHAR_RE = new RegExp("^[" + exports.NAME_CHAR + "]$", "u");
exports.NAME_RE = new RegExp("^[" + exports.NAME_START_CHAR + "][" + exports.NAME_CHAR + "]*$", "u");
exports.NMTOKEN_RE = new RegExp("^[" + exports.NAME_CHAR + "]+$", "u");
var TAB = 9;
var NL = 0xA;
var CR = 0xD;
var SPACE = 0x20;
//
// Lists.
//
/** All characters in the ``S`` production. */
exports.S_LIST = [SPACE, NL, CR, TAB];
/**
 * Determines whether a codepoint matches the ``CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR``.
 */
function isChar(c) {
  return c >= 0x0001 && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
exports.isChar = isChar;
/**
 * Determines whether a codepoint matches the ``RESTRICTED_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``RESTRICTED_CHAR``.
 */
function isRestrictedChar(c) {
  return c >= 0x1 && c <= 0x8 || c === 0xB || c === 0xC || c >= 0xE && c <= 0x1F || c >= 0x7F && c <= 0x84 || c >= 0x86 && c <= 0x9F;
}
exports.isRestrictedChar = isRestrictedChar;
/**
 * Determines whether a codepoint matches the ``CHAR`` production and does not
 * match the ``RESTRICTED_CHAR`` production. ``isCharAndNotRestricted(x)`` is
 * equivalent to ``isChar(x) && !isRestrictedChar(x)``. This function is faster
 * than running the two-call equivalent.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR`` and does not match
 * ``RESTRICTED_CHAR``.
 */
function isCharAndNotRestricted(c) {
  return c === 0x9 || c === 0xA || c === 0xD || c > 0x1F && c < 0x7F || c === 0x85 || c > 0x9F && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
exports.isCharAndNotRestricted = isCharAndNotRestricted;
/**
 * Determines whether a codepoint matches the ``S`` (space) production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``S``.
 */
function isS(c) {
  return c === SPACE || c === NL || c === CR || c === TAB;
}
exports.isS = isS;
/**
 * Determines whether a codepoint matches the ``NAME_START_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_START_CHAR``.
 */
// tslint:disable-next-line:cyclomatic-complexity
function isNameStartChar(c) {
  return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A || c === 0x3A || c === 0x5F || c === 0x200C || c === 0x200D || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
exports.isNameStartChar = isNameStartChar;
/**
 * Determines whether a codepoint matches the ``NAME_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_CHAR``.
 */
function isNameChar(c) {
  return isNameStartChar(c) || c >= 0x30 && c <= 0x39 || c === 0x2D || c === 0x2E || c === 0xB7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
exports.isNameChar = isNameChar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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